/**
 * Cookie package - Comprehensive cookie and consent management utilities
 *
 * This package provides:
 * - Basic cookie operations (get, set, delete, parse)
 * - OneTrust consent management
 * - TypeScript types and enums
 */

// Export basic cookie utilities
export {
  cookieAsObject,
  getCookie,
  setCookie,
  deleteCookie,
} from './cookie-utils'

// Export OneTrust consent management
export {
  OPTANON_DEFAULT_CONSENT,
  OPTANON_COOKIE_NAME,
  getOneTrustConsent,
  transformOneTrustConsent,
  getOneTrustConsentPreferences,
  isConsentCategoryEnabled,
  OneTrustCategories,
} from './consent'

// Export types
export type {
  CookieOptions,
  DeleteCookieOptions,
  OneTrustConsentPreferences,
} from './types'

// Legacy exports for backward compatibility
import { OneTrustCategories } from './types'
export { OneTrustCategories as ConsentCategories }
